import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@ers-cat-app/env/environment';
import { DpsWorkOrderService } from '@ers-cat-app/pages/dps-work-order/services/dps-work-order.service';
import { HourMeterRequest, Product } from '@ers/shared';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class HourMeterService {
  private readonly http = inject(HttpClient);
  private readonly dpsWorkOrderService = inject(DpsWorkOrderService);

  private readonly BASE_URL = `${environment.apiUrl}/hour-meter`;

  getProducts(): Observable<Product[]> {
    // filter on UI side for IS_METERED === 'Y'
    return this.dpsWorkOrderService.getProducts();
  }

  submit(data: {
    payload: HourMeterRequest;
    productNumber: string;
  }): Observable<any> {
    return this.http.put(`${this.BASE_URL}/submit`, data);
  }
}
